import { defineMessages } from 'react-intl'

export default defineMessages({
  contactHeaderMyBroker: {
    id: 'app.contact.header.myBroker',
    defaultMessage: 'My broker',
  },
  contactHeaderMyAgent: {
    id: 'app.contact.header.myAgent',
    defaultMessage: 'My agent',
  },
  contactHeaderOtherBranches: {
    id: 'app.contact.header.otherBranches',
    defaultMessage: 'Other Branches',
  },
})
